import { RouteComponentProps } from '@reach/router';
import React from 'react';
import { SubjectChartList } from '../../../../components/charts/ChartList';
import { TimeRangeSelect } from '../../../../components/forms';
import { TimeRangeNavigator } from '../../../../components/ui';
import EmptyState from './EmptyState';
import TimeNavigatorBar from '../../../../components/forms/TimeNavigatorBar';

interface SubjectDataProps extends RouteComponentProps {
  subject: {
    id: string;
    name: string;
    slug: string;
    trackers: {
      id: string;
      name: string;
      slug: string;
      type: TrackerType;
    }[];
  };
  setActiveTab: (value: 'SETTINGS') => void;
}

const SubjectData: React.FC<SubjectDataProps> = ({ subject, setActiveTab }) => {
  return (
    <>
      {subject.trackers.length > 0 ? (
        <>
          <TimeNavigatorBar />
          <SubjectChartList subject={subject} />
        </>
      ) : (
        <EmptyState setActiveTab={setActiveTab} />
      )}
    </>
  );
};

export default SubjectData;
